import { render } from "./HomeMobile.vue?vue&type=template&id=8a79f2b4"
import script from "./HomeMobile.vue?vue&type=script&lang=js"
export * from "./HomeMobile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/trifjolngjela/Projects/home-budget/home-budget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTabPanels,QTabPanel,QSpace,QTabs,QTab});
